/**
 * Success Page Controller
 */
class SuccessController {
    constructor($scope, $uibModal, $state, $stateParams, $window, $location) {
        'ngInject';

        //Exposing globals to another methods
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.$window = $window;
        this.$location = $location;

        this.loading = false;
        this.email = $stateParams.email;
        this.isDispositivoMobile = false;
    }

    navigateToSite() {
        this.isDispositivoMobile = this.verificaSeDispositivoMobile();

        if(this.isDispositivoMobile){
            var s = JSON.stringify({fecharModal: true});
            if(window.ReactNativeWebView){
                window.ReactNativeWebView.postMessage(s);
            } else {
                window.postMessage(s, '*');
            }
        } else {
            var currentUrl =  this.$location.absUrl().split('?')[0];
            var destinationUrl = this.checkEnviromnetByUrl(currentUrl);
            this.$window.location.href = destinationUrl;
        }
    }

    checkEnviromnetByUrl(currentUrl){
        let destinationUrl;
        if(currentUrl.includes('dev') || currentUrl.includes('desen'))
            destinationUrl = 'http://autoatendimento.cloud.dev.cooperforte.coop/';
        else if(currentUrl.includes('homol') || currentUrl.includes('hmg'))
            destinationUrl = 'http://autoatendimento.cloud.homol.cooperforte.coop/';
        else if(currentUrl.includes('eleicoes'))
            destinationUrl = 'https://eleicoes2021-homol.cf.coop.br/inscricao/';
        else
            destinationUrl = 'https://autoatendimento.cf.coop.br/';

        return destinationUrl;
    }

    verificaSeDispositivoMobile = function(){
        if(navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)) {
            return true;
        }
        else {
            return false;
        }
    }
}

export default SuccessController;


// WEBPACK FOOTER //
// ./src/app/components/views/success/success.controller.js